// extracted by mini-css-extract-plugin
module.exports = {"notmatch":"notmatch_notmatch__3u5lh","h1":"notmatch_h1__3XSt5","h2":"notmatch_h2__25A8T","link":"notmatch_link__1gVLp"};